import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error, TipoTecnico } from '@rpe/registro-personas-empresas-lib';

// LOAD
export const entityTiposTecnicoLoadRequest = createAction(
  '[ENTITYTIPOSTECNICO] Load Request'
);

export const entityTiposTecnicoLoadFailure = createAction(
  '[ENTITYTIPOSTECNICO] Load Failure',
  props<{ error: Error }>()
);

export const entityTiposTecnicoLoadSuccess = createAction(
  '[ENTITYTIPOSTECNICO] Load Success',
  props<{ items: TipoTecnico[] }>()
);
